import { type ReactElement, type ReactNode, useEffect } from "react"
import { useSelector } from "react-redux";
import { RootState } from "src/app/store";
import Modal from "src/components/Modal";
import { useForm, SubmitHandler } from "react-hook-form";
import Button from "src/components/Button";
import { OTPCodeType } from "../../types/OTPCodType";

export interface OTPModalProps {
        title: string,
        isOpen: boolean,
        onClose: () => void,
        onSubmit: (value: OTPCodeType) => void,
        children?: ReactNode
}

export default function OTPModal(props: OTPModalProps): ReactElement {
        const { register, watch, handleSubmit, reset, clearErrors, setError, formState: { errors, isSubmitting } } = useForm<OTPCodeType>({});

        const { authUser } = useSelector((state: RootState) => state.auth);

        const onSubmit: SubmitHandler<OTPCodeType> = (data) => {
                props.onSubmit(data);
                reset();
        }

        return <>
                <Modal isOpen={props.isOpen} modalSize="lg" onClose={props.onClose}>
                        <h2 className="text-lg font-bold text-center">
                                {props.title}
                        </h2>
                        <form className="flex flex-col gap-5" onSubmit={handleSubmit(onSubmit)}>
                                <div className="flex justify-center">
                                        <div className="flex flex-col">
                                                <div className="mt-4 flex gap-1">
                                                        <label className="text-gray-800 text-[15px] mb-2 block">Please check your Email:</label> <p className="font-bold">{authUser?.EmailId}</p><label> for the OTP</label>
                                                </div>
                                                <div className="relative flex items-center">
                                                        <input type="password" className="w-full text-sm text-gray-800 bg-gray-100 focus:bg-transparent pl-4 pr-10 py-3.5 rounded-xs outline-blue-600" placeholder="Enter OTP" {...register("Code", { required: "Code is required", minLength: { value: 6, message: "Code must be atleast 6 characters" }, })} />
                                                </div>
                                                {errors.Code && (
                                                        <div className="text-red-500">{errors.Code.message}</div>
                                                )}
                                        </div>
                                </div>
                                <div className="flex gap-16 justify-around">
                                        <Button className="" size="lg" type="reset" buttonStyle="delete">Reset</Button>
                                        <Button className="" size="lg" type="submit" buttonStyle="primary">Save</Button>
                                </div>
                        </form>
                        {errors.root && (
                                <div className="text-red-500 text-center">{errors.root.message}</div>
                        )}
                </Modal>
        </>
}
